import StatisticsService from '../services/statistics.service';
import store from '../store/index';
import { computed } from 'vue';

class StatisticsUtils {
  async subjectCounts() {
    const dateFrom = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.from == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.from,
    });

    const dateTo = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.to == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.to,
    });

    const organisations = computed({
      get: () => store.state.fomoStatisticsSearch.organisationsSelectArray,
    });

    const subjects = computed({
      get: () => store.state.fomoStatisticsSearch.subjectsSelectArray,
    });

    const years = computed({
      get: () => store.state.fomoStatisticsSearch.yearsSelectArray,
    });

    const scopes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedScopes,
    });

    store.commit('fomoStatisticsSearch/updateAllCustomersArray');
    const customers = computed({
      get: () => store.state.fomoStatisticsSearch.allSelectedCustomersArray,
    });
    const isMunicipality = computed({
      get: () => store.state.fomoStatisticsSearch.isMunicipality,
    });
    const kvkNumbers = computed({
      get: () => store.state.fomoStatisticsSearch.selectedKvkNumbers,
    });
    const sbiCodes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedSbiCodes,
    });
    
    await StatisticsService.subjectCounts(
      dateFrom.value,
      dateTo.value,
      organisations.value,
      subjects.value,
      customers.value,
      years.value,
      scopes.value,
      isMunicipality.value,
      kvkNumbers.value,
      sbiCodes.value,
    );
  }

  async customerCounts() {
    const dateFrom = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.from == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.from,
    });

    const dateTo = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.to == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.to,
    });

    const organisations = computed({
      get: () => store.state.fomoStatisticsSearch.organisationsSelectArray,
    });

    const subjects = computed({
      get: () => store.state.fomoStatisticsSearch.subjectsSelectArray,
    });

    const years = computed({
      get: () => store.state.fomoStatisticsSearch.yearsSelectArray,
    });

    const scopes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedScopes,
    });

    store.commit('fomoStatisticsSearch/updateAllCustomersArray');
    const customers = computed({
      get: () => store.state.fomoStatisticsSearch.allSelectedCustomersArray,
    });
    const isMunicipality = computed({
      get: () => store.state.fomoStatisticsSearch.isMunicipality,
    });
    const kvkNumbers = computed({
      get: () => store.state.fomoStatisticsSearch.selectedKvkNumbers,
    });
    const sbiCodes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedSbiCodes,
    })

    await StatisticsService.customerCounts(
      dateFrom.value,
      dateTo.value,
      organisations.value,
      subjects.value,
      customers.value,
      years.value,
      scopes.value,
      isMunicipality.value,
      kvkNumbers.value,
      sbiCodes.value
    );
  }

  async customerSubdsidy() {
    const dateFrom = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.from == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.from,
    });

    const dateTo = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.to == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.to,
    });

    const organisations = computed({
      get: () => store.state.fomoStatisticsSearch.organisationsSelectArray,
    });

    const subjects = computed({
      get: () => store.state.fomoStatisticsSearch.subjectsSelectArray,
    });

    const years = computed({
      get: () => store.state.fomoStatisticsSearch.yearsSelectArray,
    });

    const scopes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedScopes,
    });

    store.commit('fomoStatisticsSearch/updateAllCustomersArray');
    const customers = computed({
      get: () => store.state.fomoStatisticsSearch.allSelectedCustomersArray,
    });
    const isMunicipality = computed({
      get: () => store.state.fomoStatisticsSearch.isMunicipality,
    });
    const kvkNumbers = computed({
      get: () => store.state.fomoStatisticsSearch.selectedKvkNumbers,
    });
    const sbiCodes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedSbiCodes,
    });
    await StatisticsService.customerSubsidy(
      dateFrom.value,
      dateTo.value,
      organisations.value,
      subjects.value,
      customers.value,
      years.value,
      scopes.value,
      isMunicipality.value,
      kvkNumbers.value,
      sbiCodes.value,
    );
  }

  async customerSchemes(customerName, year) {
    await StatisticsService.customerSchemes(customerName, year);
  }

  async filterRecords() {
    const dateFrom = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.from == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.from,
    });

    const dateTo = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.to == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.to,
    });

    const organisations = computed({
      get: () => store.state.fomoStatisticsSearch.organisationsSelectArray,
    });

    const subjects = computed({
      get: () => store.state.fomoStatisticsSearch.subjectsSelectArray,
    });

    const years = computed({
      get: () => store.state.fomoStatisticsSearch.yearsSelectArray,
    });

    const scopes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedScopes,
    });

    store.commit('fomoStatisticsSearch/updateAllCustomersArray');
    const customers = computed({
      get: () => store.state.fomoStatisticsSearch.allSelectedCustomersArray,
    });

    const isMunicipality = computed({
      get: () => store.state.fomoStatisticsSearch.isMunicipality,
    })

    const kvkNumbers = computed({
      get: () => store.state.fomoStatisticsSearch.selectedKvkNumbers,
    })

    const sbiCodes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedSbiCodes,
    })

    await StatisticsService.filterRecords(
      dateFrom.value,
      dateTo.value,
      organisations.value,
      subjects.value,
      customers.value,
      years.value,
      scopes.value,
      isMunicipality.value,
      kvkNumbers.value,
      sbiCodes.value,
    );
  }

  async exportRecords() {
    const dateFrom = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.from == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.from,
    });

    const dateTo = computed({
      get: () =>
        store.state.fomoStatisticsSearch.daysRange.to == ''
          ? null
          : store.state.fomoStatisticsSearch.daysRange.to,
    });

    const organisations = computed({
      get: () => store.state.fomoStatisticsSearch.organisationsSelectArray,
    });

    const subjects = computed({
      get: () => store.state.fomoStatisticsSearch.subjectsSelectArray,
    });

    store.commit('fomoStatisticsSearch/updateAllCustomersArray');
    const customers = computed({
      get: () => store.state.fomoStatisticsSearch.allSelectedCustomersArray,
    });
    
    const years = computed({
      get: () => store.state.fomoStatisticsSearch.yearsSelectArray,
    });

    const scopes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedScopes,
    });
    const isMunicipality = computed({
      get: () => store.state.fomoStatisticsSearch.isMunicipality,
    });
    const kvkNumbers = computed({
      get: () => store.state.fomoStatisticsSearch.selectedKvkNumbers,
    });
    const sbiCodes = computed({
      get: () => store.state.fomoStatisticsSearch.selectedSbiCodes,
    })

    await StatisticsService.exportRecords(
      dateFrom.value,
      dateTo.value,
      organisations.value,
      subjects.value,
      customers.value,
      years.value,
      scopes.value,
      isMunicipality.value,
      kvkNumbers.value,
      sbiCodes.value
    );
  }
}

export default new StatisticsUtils();
